module.exports = __webpack_public_path__ + "img/30coin.79b66ef6.png";